import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, FileText } from 'lucide-react';

export default function OrderView() {
  const { orderId } = useParams();
  
  return (
    <div className="min-h-screen bg-slate-50">
      <nav className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 flex items-center h-16">
          <Link to="/cont" className="flex items-center gap-2 text-slate-600 hover:text-slate-900">
            <ArrowLeft className="h-5 w-5" />
            Înapoi la dashboard
          </Link>
        </div>
      </nav>
      <main className="max-w-4xl mx-auto px-6 py-8">
        <div className="bg-white rounded-xl border border-slate-200 p-8">
          <div className="flex items-center gap-3 mb-6">
            <FileText className="h-8 w-8 text-blue-600" />
            <h1 className="text-2xl font-semibold text-slate-900">
              Comanda #{orderId ? orderId.slice(-8).toUpperCase() : 'N/A'}
            </h1>
          </div>
          <p className="text-slate-600">
            Detaliile comenzii sunt disponibile după autentificare în dashboard.
          </p>
          <Link to="/cont" className="inline-block mt-6">
            <Button className="bg-blue-600 hover:bg-blue-700 text-white">
              Mergi la Dashboard
            </Button>
          </Link>
        </div>
      </main>
    </div>
  );
}
